import React, { Component, Fragment } from 'react';
import { get, isNil } from 'lodash';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import classNames from 'classnames';

import { LoadingBase } from 'Components';
import { WEEKLY_NUTRIENTS } from 'Common/Components/RecipeSearch';
import { ANALYSIS_REQUIREMENT_DESCRIPTION_MAP } from '../constants';
import { formatAnalysisDescription } from '../utilities';

import 'Styles/pages/managemenu/weeklyAnalysis.less';

class WeeklyAnalysisPanel extends Component {
  static propTypes = {
    nutritionStandard: PropTypes.string,
    weekNumber: PropTypes.number.isRequired,
    weeklyRequirements: PropTypes.arrayOf(PropTypes.object).isRequired,
    analyzing: PropTypes.bool,
    className: PropTypes.string,
    onRequirementClick: PropTypes.func,
  };

  static defaultProps = {
    analyzing: false,
    onRequirementClick: () => {},
  };

  get headerClass() {
    const { weekNumber } = this.props;

    // There are 4 colors to cycle through based on the week number
    // Subtract 1 since week numbers start from 1
    const remainder = (weekNumber - 1) % 4;

    return classNames('panel-header', {
      blue: remainder === 0,
      yellow: remainder === 1,
      green: remainder === 2,
      teal: remainder === 3,
    });
  }

  formatRequirementDescription(description) {
    if (ANALYSIS_REQUIREMENT_DESCRIPTION_MAP[description]) {
      return ANALYSIS_REQUIREMENT_DESCRIPTION_MAP[description];
    }
    return description;
  }

  onRequirementClick = item => () => {
    this.props.onRequirementClick(item);
  };

  renderPanelContent() {
    const { analyzing, weeklyRequirements, weekNumber } = this.props;
    const requirementList = get(weeklyRequirements[weekNumber - 1], 'List', []);

    if (analyzing) {
      return <LoadingBase className="weekly-analysis-loader" />;
    }

    return (
      <Fragment>
        <div className="column-labels">
          <div className="requirement-status label">D</div>
          <div className="requirement-status label">W</div>
        </div>
        {requirementList.map((item, index) => {
          const isWeeklyNutrient =
            WEEKLY_NUTRIENTS.findIndex(
              x => x.Description === item.Description
            ) > -1;
          return (
            <div
              className={classNames('meal-requirement', {
                'weekly-requirement': isWeeklyNutrient,
              })}
              key={index}
              onClick={this.onRequirementClick(item)}
            >
              <div className="requirement-status">
                {!isNil(item.DailyMet) && (
                  <Icon
                    className={classNames({
                      'check check-icon': item.DailyMet,
                      'exclamation triangle yellow': !item.DailyMet,
                    })}
                  />
                )}
              </div>
              <div className="requirement-status">
                {!isNil(item.WeeklyMet) && (
                  <Icon
                    className={classNames({
                      'check check-icon': item.WeeklyMet,
                      'exclamation triangle yellow': !item.WeeklyMet,
                    })}
                  />
                )}
              </div>
              <div className="requirement-description">{`${this.formatRequirementDescription(
                item.Description
              )} ${formatAnalysisDescription(item)}`}</div>
            </div>
          );
        })}
      </Fragment>
    );
  }

  onScroll = e => {
    // Scrolling will propagate to the scroll event handler on the scroll container
    // so stop it here to avoid awkward re-rendering behavior.
    e.stopPropagation();
  };

  render() {
    const {
      nutritionStandard,
      weekNumber,
      className,
      style,
      lassoMode,
    } = this.props;

    return (
      <div
        className={classNames('weekly-analysis-panel', className, {
          'hide-text-selection': lassoMode,
        })}
        style={style}
        onScroll={this.onScroll}
      >
        <div className={this.headerClass}>
          <div>Week {weekNumber} USDA Meal Standards</div>
          <div>{nutritionStandard}</div>
        </div>
        <div className="panel-body">{this.renderPanelContent()}</div>
        {/* <div className="panel-footer">
          <div className="footer-content">
            Cost Per Serving (Day): ${formatToCash(0)} <br />
            Cost Per Serving (Week): ${formatToCash(0)} <br />
            Cost Per Serving (Cycle): ${formatToCash(0)}
          </div>
        </div> */}
      </div>
    );
  }
}

export { WeeklyAnalysisPanel };



// WEBPACK FOOTER //
// ./src/pages/managemenu/subpages/editmenu/components/WeeklyAnalysisPanel.js